'use strict'

import svgPanZoom from 'svg-pan-zoom'

export const schemePanZoom = (() => {
  let observer = null

  const resizeHandler = (panZoom) => {
    panZoom.resize()
    panZoom.fit()
    panZoom.center()
  }

  const initPanZoom = (schemeContainer) => {
    const scheme = schemeContainer.querySelector('svg')

    if (!scheme) return

    const panZoom = svgPanZoom(scheme, {
      mouseWheelZoomEnabled: false,
      zoomEnabled: false,
      dblClickZoomEnabled: false,
      controlIconsEnabled: false,
      fit: true,
      center: true,
      onZoom: function (zoom) {
        schemeContainer.dataset.schemePanZoom = Math.round(zoom)
      },
    })

    window.addEventListener('resize', resizeHandler(panZoom))

    const buttonZoomIn = schemeContainer.querySelector('[data-scheme-pan-zoom-in]')
    const buttonZoomOut = schemeContainer.querySelector('[data-scheme-pan-zoom-out]')

    const steps = [1, 2.5, 5, 7.5]
    let idx = 0

    buttonZoomIn.addEventListener('click', () => {
      if (idx === steps.length - 1) return

      idx = (idx + 1) % steps.length

      panZoom.zoom(steps[idx])
    })

    buttonZoomOut.addEventListener('click', () => {
      if (idx === 0) return

      idx = (idx - 1) % steps.length

      panZoom.zoom(steps[idx])
    })

    const houses = schemeContainer.querySelectorAll('[id^="house-"]')

    houses.forEach(house => {
      house.addEventListener('click', () => {
        house.classList.add('active')
        setPopup(schemeContainer, house.id)
      })
    })
  }

  const initStatuses = async (schemeContainer) => {
    const siteHandle = schemeContainer.dataset.siteHandle
    const productId = schemeContainer.dataset.product

    const params = new URLSearchParams({
      siteHandle,
      productId
    })
    const url = `/api/offers/statuses?${params.toString()}`

    try {
      const response = await fetch(url, {
        headers: {
          'Accept': 'application/json'
        }
      })

      if (!response.ok) {
        throw new Error(response.statusText)
      }

      const data = await response.json()

      for (const houseId in data) {
        const status = data[houseId]
        const pin = schemeContainer.querySelector(`[id="${houseId}"]`)

        if (!pin) continue

        pin.classList.add(status ? 'available' : 'unavailable')
      }
    } catch (error) {
      console.error('Error fetching statuses', error)
    }
  }

  const setPopup = (schemeContainer, houseId) => {
    const siteHandle = schemeContainer.dataset.siteHandle
    const productId = schemeContainer.dataset.product
    const popup = schemeContainer.querySelector('[data-scheme-pan-zoom-popup]')

    if (!popup) return

    popup.innerHTML = '<div class="w-10 aspect-square border-4 border-light-border border-t-primary rounded-full animate-spin"></div>'
    popup.classList.add('active')

    fetch(`/scheme-popup/${siteHandle}/${productId}/${houseId}`)
      .then(response => response.text())
      .then(html => {
        popup.innerHTML = html

        const closeButton = popup.querySelector('[data-popup-close]')
        const openFormButton = popup.querySelector('[data-popup-open-form]')
        const form = popup.querySelector('[data-popup-form]')
        const info = popup.querySelector('[data-popup-info]')

        if (openFormButton) {
          openFormButton.addEventListener('click', () => {
            info.classList.add('hidden')
            form.classList.remove('hidden')
          })
        }

        closeButton.addEventListener('click', () => {
          popup.classList.remove('active')

          const activeHouses = schemeContainer.querySelectorAll('[id^="house-"].active')

          activeHouses.forEach(house => {
            house.classList.remove('active')
          })

          info.classList.remove('hidden')
          form.classList.add('hidden')
        })
      })
  }

  const initScheme = (schemeContainer) => {
    const schemePanZoomContainer = schemeContainer.querySelector('[data-scheme-pan-zoom-container]')

    if (!schemePanZoomContainer) return

    const src = schemePanZoomContainer.dataset.schemePanZoomContainer

    if (!src) return

    fetch(src)
      .then(response => response.text())
      .then(svg => {
        schemePanZoomContainer.innerHTML = svg
        initPanZoom(schemeContainer)
        initStatuses(schemeContainer)
      })
  }

  const handleSchemeIntersect = (entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return

      const schemeContainer = entry.target

      initScheme(schemeContainer)

      observer.unobserve(schemeContainer)
    })
  }

  const init = () => {
    const schemeContainers = document.querySelectorAll('[data-scheme-pan-zoom]')

    observer = new IntersectionObserver(handleSchemeIntersect, {
      root: null,
      rootMargin: '0px',
      threshold: 0.5
    })

    schemeContainers.forEach(schemeContainer => {
      observer.observe(schemeContainer)
    })
  }

  return {
    init
  }
})()